import * as React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ThankYou from "./pages/ThankYou";
import Dashboard from "./pages/Dashboard/Dashboard";
import ProductPage from "./pages/ProductPage";
import Register from "./pages/Dashboard/Register";
import Login from "./pages/Dashboard/Login";
import PrivateRoute from "./pages/Dashboard/PrivateRoute";
import SingleCategory from "./pages/SingleCategory";
import OrderPage from "./pages/OrderPage";
import Contact from "./pages/Contact";
import Shop from "./pages/Shop";
import LegalPage from "./pages/LegalPage";
import Checkout from "./pages/Checkout";
import LandingPage from "./pages/Landing/LandingPage";
import ThankYouPage from "./pages/ThankYou/Thankyou";
import LandingPageEditor from "./pages/Dashboard/LandingPage/LandingPageEditor";
import { ProductContext } from "./context/ProductsContext";
import { initFacebookPixels } from "./pixel";
import axios from "axios";
import { config } from "./config";


function App() {

  const { pixel } = React.useContext(ProductContext);

  const pixelInitialized = React.useRef(false);
  const apiUrl = config.apiUrl;

React.useEffect(() => {
  if (pixel?.length > 0 && !pixelInitialized.current) {
    // ১. একটি কমন ইভেন্ট আইডি তৈরি করুন
    const commonEventId = `PV_${Date.now()}_${Math.floor(Math.random() * 999999)}`;

    // ২. পিক্সেল ইনিশিয়ালাইজ করুন এবং আইডিটি পাস করুন
    initFacebookPixels(pixel, commonEventId); 
    pixelInitialized.current = true;

    // ৩. সার্ভারে (CAPI) একই আইডি পাঠান
    axios.post(`${apiUrl}/fb-track`, {
      event: "PageView",
      event_id: commonEventId, // একই আইডি
      event_source_url: window.location.href,
      fbp: document.cookie.match(/_fbp=([^;]+)/)?.[1] || null,
      fbc: document.cookie.match(/_fbc=([^;]+)/)?.[1] || null
    }).catch(err => console.log("CAPI PageView Error:", err));
  }
}, [pixel]);


  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProductPage />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/:slug" element={<OrderPage />} />
          <Route path="/thankyou/:id" element={<ThankYou />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route path="/category/:id" element={<SingleCategory />} />
          
          <Route path="/editor/:id" element={<LandingPageEditor />} />
          <Route path="/offer/:slug" element={<LandingPage />} />

          <Route path="/contact" element={<Contact />} />
           <Route path="/checkout" element={<Checkout />} />
           <Route path="/lp" element={<LandingPage />} />
           <Route path="/th-1" element={<ThankYouPage />} />
          
          <Route path="/dashboard" element={
            <PrivateRoute allowedRoles={["admin", "moderator"]}>
              <Dashboard />
            </PrivateRoute>
          } />
          
        </Routes>
      </Router>
    </div>
  );
}

export default App;